import { flatMap } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Small, MediumUp } from 'components/MediaQuery';

import DesktopSelector from './DesktopSelector';
import MobileSelector from './MobileSelector';

const PdpProductSelector = props => {
  const { groupedProducts, ...otherProps } = props;

  const products = flatMap(groupedProducts, prods => prods);

  return (
    <div className="PdpProductSelector mb-4">
      <Small>
        <MobileSelector products={products} {...otherProps} />
      </Small>
      <MediumUp>
        <DesktopSelector products={groupedProducts} {...otherProps} />
      </MediumUp>
    </div>
  );
};

PdpProductSelector.propTypes = {
  isLoading: PropTypes.bool,
  groupedProducts: PropTypes.shape({}),
  onSelect: PropTypes.func.isRequired,
  currentProductEdition: PropTypes.string,
  currentProductName: PropTypes.string,
  currentProductHandle: PropTypes.string,
  currentProductPrice: PropTypes.string,
  isSalePdp: PropTypes.bool.isRequired,
};

PdpProductSelector.defaultProps = {
  isLoading: false,
  groupedProducts: {},
  currentProductEdition: null,
  currentProductName: null,
  currentProductHandle: null,
  currentProductPrice: null,
};

export default PdpProductSelector;
